import LeaveHTMLPreviewBaseSection from './LeaveHTMLPreviewBaseSection'
import {ReportGroupingLevel} from '../../../constants'

export default function LeaveHTMLPreviewGroupingSection() {}

LeaveHTMLPreviewGroupingSection.prototype = new LeaveHTMLPreviewBaseSection();

LeaveHTMLPreviewGroupingSection.prototype.init = function( firstGroupingLevel, secondGroupingLevel, columnsStrategy )
{
    LeaveHTMLPreviewBaseSection.prototype.init.call(this, columnsStrategy);

    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    return this;
};

LeaveHTMLPreviewGroupingSection.prototype.addRows = function( tBody )
{
    this.addRow( tBody, this.makeGroupingTotalRow() );

    let countRows = 5
    let numberRow = 0

    while (true)
    {
        this.addFirstGroupingRow( tBody);
        numberRow++;
        if( numberRow >= countRows )
            break;

        if (this.secondGroupingLevel !== ReportGroupingLevel.NONE )
        {
            this.addSecondGroupingRow(tBody);
            numberRow++;
            if( numberRow >= countRows )
                break;

            if ( ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.secondGroupingLevel, [this.firstGroupingLevel]) )
            {
                this.addSecondGroupingRow(tBody);
                numberRow++;
                if( numberRow >= countRows )
                    break;
            }
        }
    }
};

LeaveHTMLPreviewGroupingSection.prototype.makeGroupingTotalRow = function ()
{
    return this.createRowWithMainAndDataCells("groupingTotal", this.message("report.total"), "groupingTotalCell" );
};

LeaveHTMLPreviewGroupingSection.prototype.addFirstGroupingRow = function(tBody){
    this.addRow( tBody, this.makeGroupingRow( "firstGrouping", "firstLevel", this.firstGroupingLevel ) );
};

LeaveHTMLPreviewGroupingSection.prototype.addSecondGroupingRow = function(tBody){
    this.addRow( tBody, this.makeGroupingRow( "secondGrouping", "secondLevel", this.secondGroupingLevel ) );
};


LeaveHTMLPreviewGroupingSection.prototype.makeGroupingRow = function ( rowClassName, cellClassName, groupingLevel )
{
    return this.createRowWithMainAndDataCells(rowClassName, ReportPreviewUtils.getLevelPreviewName(groupingLevel), cellClassName );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewGroupingSection.js